module.exports = __webpack_public_path__ + "assets/images/hemoglobin_g.46f41b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hemoglobin_g.png
// module id = 732
// module chunks = 1